export const noDateGroupLabel = "Ita9nd";
export const laterGroupLabel = "ry2Emc";
export const nextWeekGroupLabel = "w5_Sx";
export const tomorrowGroupLabel = "KHSVY";
export const todayGroupLabel = "eR8ku";
export default {noDateGroupLabel,laterGroupLabel,nextWeekGroupLabel,tomorrowGroupLabel,todayGroupLabel};